module.exports = __webpack_public_path__ + "img/approve.d0396a26.png";